(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yoganastix-boyfriend-pilot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yx-boyfriend-pilot')) {
  customElements.define('yx-boyfriend-pilot', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-yx-config]').textContent);
      this.update = () => {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const id = form?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant');
        const v = this.config.variants.find(item => String(item.id) === String(id));
        const line = this.querySelector('[data-yx-dispatch]');
        if (!v) return;
        this.current = v;
        const standard = ['S','M','L'].includes(v.options[1]);
        line.textContent = !v.available ? this.config.unavailable : standard && v.tracked && v.quantity > 0 ? this.config.ready : this.config.made;
      };
      this.onChange = () => { this.update(); clearTimeout(this.timer); this.timer=setTimeout(this.update,700); };
      document.addEventListener('change',this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange,this.update);
      this.querySelectorAll('[data-yx-fabric]').forEach(link => link.addEventListener('click',()=>{
        if (this.current) {
          try { sessionStorage.setItem('yx-t101-choice',JSON.stringify({options:this.current.options,expires:Date.now()+60000,target:new URL(link.href).pathname})); } catch(e) {}
        }
      }));
      try {
        const saved=JSON.parse(sessionStorage.getItem('yx-t101-choice')||'null');
        if(saved && saved.expires>Date.now() && saved.target===location.pathname){
          sessionStorage.removeItem('yx-t101-choice');
          const exact=this.config.variants.find(v=>v.options[0]===saved.options[0] && v.options[1]===saved.options[1]);
          const match=exact;
          if(match && new URL(location.href).searchParams.get('variant')!==String(match.id)){
            const url=new URL(location.href); url.searchParams.set('variant',match.id); location.replace(url); return;
          }
        }
      } catch(e) {}
      this.update();
    }
    disconnectedCallback(){document.removeEventListener('change',this.onChange);clearTimeout(this.timer);this.unsubscribe?.();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
